import { IconButton } from '@blend-ed/blendx-ui';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

function ChatInput({ value, onChange, onSend, placeholder, intl }) {
  return (
    <div className="ai-tutor__input">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && onSend()}
        placeholder={intl.formatMessage(placeholder)}
        className="ai-tutor__input-field"
      />
      <IconButton
        icon="send-plane"
        iconType="line"
        variant="primary"
        size="sm"
        onClick={onSend}
        disabled={!value.trim()}
      />
    </div>
  );
}

ChatInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  placeholder: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(ChatInput); 